{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "$id": "https://www.w3.org/ns/pub-schema/manifest/module/localizable.schema.json",
  "title": "Localizable String or Object",
  "anyOf": [
    {
      "type": "string"
    },
    {
      "type": "array",
      "items": {
        "anyOf": [
          {
            "type": "string"
          },
          {
            "$ref": "localizable-object.schema.json"
          }
        ]
      }
    },
    {
      "$ref": "localizable-object.schema.json"
    }
  ]
}
